import * as React from 'react';

import {getDisplayName} from 'nutshell-core/utils';

type State = {
    isOffline: boolean;
};

export function addOffline(WrappedComponent: React.ComponentType<any>) {
    return class HOC extends React.Component<any, State> {
        static displayName = `HOC(${getDisplayName(WrappedComponent)})`;

        constructor() {
            // @ts-expect-error
            super();
            this.state = {
                isOffline: false,
            };
        }

        componentDidMount() {
            window.addEventListener('online', this.handleComputerCameBackOnline);
        }

        componentWillUnmount() {
            window.removeEventListener('online', this.handleComputerCameBackOnline);
        }

        render() {
            return (
                <WrappedComponent
                    {...this.props}
                    isOffline={this.state.isOffline}
                    onError={this.handleError}
                />
            );
        }

        handleComputerCameBackOnline = () => {
            this.setState({isOffline: false});
        };

        handleError = () => {
            if (!navigator.onLine) {
                this.setState({isOffline: true});
            }
        };
    };
}
